var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picker',{staticClass:"emoji-picker mt-3",attrs:{"title":"Select Emoji","native":true,"data":_vm.emojiIndex},on:{"select":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }